import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import OurStory from './components/OurStory';
import ContactFooter from '@/pages/home/components/ContactFooter';
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <main className="overflow-x-hidden">
      <Navbar />
      {/* Spacer for fixed navbar */}
      <div className="h-20" />
      {/* Page Header */}
      <section className="bg-teal-50 py-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-teal-400 rounded-full" />
            <span className="text-gray-500 text-sm font-medium tracking-wide uppercase">{t('about.aboutTag')}</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            {t('about.title1')} <span className="text-teal-400">{t('about.title2')}</span>
          </h1>
          <p className="text-gray-500 text-lg mt-4 max-w-2xl mx-auto">
            {t('about.subtitle')}
          </p>
        </div>
      </section>
      <OurStory />
      <ContactFooter />
    </main>
  );
}